<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
    (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
    [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
    [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>

<c-modal [visible]="bShowResolution" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="resolutionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Enter the resolution</h5>
            <button (click)="closeResolutionModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
            <c-input-group class="mb-3 has-validation">
                <span cInputGroupText>
                    Resolution
                </span>
                <input [valid]="bValidResolution" cFormControl formControlName="resolutionControl" id="RejectReason"
                    type="text" />
                <c-form-feedback [valid]="bValidResolution">{{ifResolutionValid()}}</c-form-feedback>
            </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeResolutionModal()">
                Cancel
            </button>
            <button cButton color="primary" (click)="processResolution()">Resolve</button>
        </c-modal-footer>
    </form>
</c-modal>

<div *ngIf="true">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
        <c-container fluid>
            <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="getServices()">
                <c-row [gutter]="{gy: 1}">
                    <c-col md="auto">
                        <c-input-group class="has-validation">
                            <span cInputGroupText>
                                Service Type sdasdasdasdasdasdasd
                            </span>
                            <select cSelect id="serviceType" name="serviceType"
                                formControlName="searchServiceTypeControl" (change)="onSelectChange()">
                                <option *ngFor="let serviceType of serviceTypes" [value]="serviceType.value">
                                    {{serviceType.key}}
                                </option>
                            </select>
                        </c-input-group>
                    </c-col>
                </c-row>
                <c-row [gutter]="{gy: 1}">
                    <c-col lg="5">
                        <c-date-range-picker [startDate]="startDate" [endDate]="endDate"
                            (startDateChange)="onStartDateChane($event)"
                            (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
                    </c-col>
                    <c-col md="auto">
                        <c-input-group class="has-validation">
                            <span cInputGroupText>
                                Ticket Type
                            </span>
                            <select cSelect id="ticketType" name="ticketType" formControlName="searchTicketTypeControl"
                                (change)="onSelectChange()">
                                <option>Open Tickets</option>
                                <option>Closed Tickets</option>
                                <option>All Tickets</option>
                            </select>
                        </c-input-group>
                    </c-col>
                    <c-col md="auto">
                        <button cButton type="submit">
                            Search
                        </button>
                    </c-col>
                </c-row>
            </form>
        </c-container>
    </c-navbar>

    <c-smart-table *ngIf="!showUserForm" [columnSorter]="true" [columns]="columns" [columnFilter]="true"
        [itemsPerPageSelect]="true" [itemsPerPage]="15" [items]="serviceData" [tableBodyProps]="{ align: 'middle' }"
        [tableProps]="{ hover: true, striped: true, responsive: true }" clickableRows header pagination
        (rowClick)="onRowClick($event)">
        <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
            <td>
                <ng-container [ngSwitch]="columnName">
                    <ng-container *ngSwitchCase="'requestedOn'">
                        {{(getDisplayDate(item))}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'resolvedOn'">
                        {{(getResolutionDate(item))}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'isOpen'">
                        <c-badge [color]="getStatusBadge(item)">
                            {{(getStatus(item))}}
                        </c-badge>
                    </ng-container>
                    <ng-container *ngSwitchCase="'requestId'">
                        <button cButton size="sm" *ngIf="showResolveButton(item)"
                            (click)="showResolutionModal(item)">{{'Update Status'}}</button>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{tdContent}}
                    </ng-container>
                </ng-container>
            </td>
        </ng-template>
    </c-smart-table>

    <div *ngIf="showUserForm" style="margin-top:20px;background-color: #fff;padding: 32px;">
        <div class="section-title">Customer Details</div>

        <form cForm [formGroup]="userForm" class="needs-validation" [gutter]="3" novalidate>
            <div class="row">
                <div class="col-6">
                    <label cLabel for="inputCIF">CIF</label>
                    <input cFormControl id="inputCIF" type="text" formControlName="customerCIF"/>
                  </div>
            </div>
            <div class="row">              
              <div class="col-6">
                <label cLabel for="inputName">Full Name</label>
                <input readonly cFormControl id="inputName" type="text" formControlName="customerName" />
              </div>
              <div class="col-6">
                <label cLabel for="inputEmail">Email</label>
                <input readonly cFormControl id="inputEmail" type="email" formControlName="customerEmail" />
              </div>
            </div>
            <div class="row pt-2">              
              <div class="col-6">
                <label cLabel for="inputMobileNumber">Mobile Number</label>
                <input readonly cFormControl id="inputMobileNumber" type="tel" formControlName="customerMobile" />
              </div>
              <div class="col-6">
                <label cLabel for="ddlClientCategory">Client Category</label>
                <select cSelect id="ddlClientCategory" name="clientCategory" formControlName="clientCategory">
                    <option value="">Select</option>
                    <option value="RETAIL.CLIENT">Retail Client</option>
                    <option value="PROFESSIONAL.CLIENT">Professional Client</option>                    
                </select>
              </div>
             
            </div>
          <div class="row pt-2"> 
            <div class="section-title">Documents</div>
                            <!-- document.component.html -->
                <div class="col-4" *ngFor="let doc of documents">
                  
                    <button (click)="downloadDocument(doc)"   class="btn btn-default w-100 mb-2">
                    {{ doc.documentName }}
                    </button>
               
                </div> 
          </div>
  
            <div class="row" style="margin-top: 32px;padding-bottom:32px;">
                <div class="col-6 d-flex gap-24">
                    <button cButton color="light" size="lg" type="button" (click)="resetForm()">
                        Reset
                    </button>
                    <button cButton color="primary" size="lg" type="submit" (click)="onUserFormSaveClick();">
                        Save
                    </button>
                </div>                
            </div>
          </form>
    </div>
</div>